import { useMemo } from 'react';
import { useDispatch } from 'react-redux';
import useReactRouter from 'use-react-router';
import qs from 'query-string';
import { pipe, pick, pickBy, complement, isNil } from 'ramda';
import {
  TwoWayHybridApply,
  setTwoWayHybridApply,
} from 'state/twoWayHybridApply';
import canUseDOM from 'utils/canUseDOM';
import useReferrerQueryParameters from 'hooks/useReferrerQueryParameters';

const initialDataKeys = [
  'echoSessionId',
  'apprlCallBackUrl',
  'nonApprlCallBackUrl',
];

const useLoadInitialTwoWayData = () => {
  const dispatch = useDispatch();
  const { location } = useReactRouter();
  const referredParameters = useReferrerQueryParameters();
  const query = useMemo(() => {
    const originalQuery = qs.parse(location.search, {
      parseBooleans: true,
    });
    return { ...referredParameters, ...originalQuery };
  }, [location.search, referredParameters]);

  // This is done on the server side to preload the Redux state.
  if (!canUseDOM) {
    const details = pipe(
      pick(initialDataKeys),
      pickBy((v, _) => complement(isNil)(v) && v),
    )(query) as Partial<TwoWayHybridApply>;

    if (details['apprlCallBackUrl']) {
      details['apprlCallBackUrl'] = decodeURI(details['apprlCallBackUrl']);
    }

    if (details['nonApprlCallBackUrl']) {
      details['nonApprlCallBackUrl'] = decodeURI(
        details['nonApprlCallBackUrl'],
      );
    }

    dispatch(setTwoWayHybridApply(details));
  }
};

export default useLoadInitialTwoWayData;
